import type {
  ContactClass,
  ContactType,
  ContactStateType,
  NotificationOptions,
  PermissionsOptions,
} from '../types';

type NotificationType = keyof NotificationOptions;
type PermissionsType = keyof PermissionsOptions;

const notifications: Record<ContactClass, Record<NotificationType, boolean>> = {
  contact: {
    Booked: true,
    Confirmed: true,
    Cancelled: true,
    Deny: true,
    'Time Change': true,
    'Action Required': false,
    'Feedback Collected': false,
  },

  agent: {
    Booked: true,
    Confirmed: true,
    Cancelled: true,
    Deny: true,
    'Time Change': true,
    'Action Required': false,
    'Feedback Collected': false,
  },

  concierge: {
    Booked: false,
    Confirmed: false,
    Cancelled: false,
    Deny: false,
    'Time Change': false,
    'Action Required': false,
    'Feedback Collected': false,
  },

  buyer: {
    Booked: false,
    Confirmed: true,
    Cancelled: true,
    Deny: false,
    'Time Change': false,
    'Action Required': false,
    'Feedback Collected': false,
  },
};

const permissions: Record<ContactClass, Record<PermissionsType, boolean>> = {
  agent: {
    canConfirmAppts: true,
    canDenyAppts: true,
    canSuggestTime: true,
    mustConfirm: false,
  },
  contact: {
    canConfirmAppts: true,
    canDenyAppts: false,
    canSuggestTime: false,
    mustConfirm: false,
  },
  concierge: {
    canConfirmAppts: false,
    canDenyAppts: false,
    canSuggestTime: false,
    mustConfirm: false,
  },
  buyer: {
    canConfirmAppts: false,
    canDenyAppts: false,
    canSuggestTime: false,
    mustConfirm: false,
  },
};

const getGenericType = (type: ContactType) => {
  switch (type) {
    case 'Seller':
    case 'Tenant':
    case 'Landlord/Manager':
      return 'contact';
    case 'Agent':
      return 'agent';
    case 'Concierge':
      return 'concierge';
    case 'Buyer':
      return 'buyer';
    default:
      throw new Error('Invalid contact type');
  }
};

export function getDefaultContact(
  type: ContactType = 'Seller',
  feedbackSendToSeller?: boolean,
): ContactStateType {
  const genericContactType = getGenericType(type);

  return {
    contactId: undefined,
    type,
    importance: 'Primary',

    firstName: '',
    lastName: '',

    email: '',
    deliveries: {
      Email: type !== 'Concierge',
    },
    pronoun: [],
    phone: [
      {
        mustCall: type === 'Concierge',
        number: '',
        sendSms: false,
        type: 'Primary',
      },
    ],

    holdAppointments: false,

    notifications: {
      ...notifications[genericContactType],
      ...(type === 'Seller' &&
        feedbackSendToSeller && { 'Feedback Collected': true }),
    },
    ...permissions[genericContactType],
  };
}
